// extracted by mini-css-extract-plugin
export default {"company-benefit":"CompanyBenefit_company-benefit__dU8XY","company-benefit__icon":"CompanyBenefit_company-benefit__icon__rN9rI"};